import { render, staticRenderFns } from "./STextArea.vue?vue&type=template&id=ec4dd038"
import script from "./STextArea.ts?vue&type=script&lang=ts&external"
export * from "./STextArea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports